import App from "./App";
import Vue from "vue";

// import VueCompositionApi from '@vue/composition-api'
// Vue.use(VueCompositionApi)

// Webpack
const isDevelop = process.env.NODE_ENV == "development";
Vue.config.devtools = isDevelop;
Vue.config.performance = false;
Vue.config.productionTip = false;
Vue.config.debug = false;
Vue.config.silent = !isDevelop;

// iView
import ViewUI from "view-design-fork";
import "view-design-fork/dist/styles/iview.css";
// import "./theme/index.less";
// import "./theme/rcm.theme.less";
// 生產環境使用外部提供主題
if (isDevelop) {
    require("./theme/rcm.theme.less");
}

// import { Network } from "vue-vis-network";
// Vue.component("network", Network);

Vue.use(ViewUI);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import ExplainPoptip from "@/components/PoptipInfos/ExplainPoptip";
Vue.component("ExplainPoptip", ExplainPoptip);

import ExplainBtn from "@/components/ExplainBtn";
Vue.component("ExplainBtn", ExplainBtn);

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
Vue.component("v-select", vSelect);

import ClearWafBtn from "@/components/ClearWafBtn";
Vue.component("ClearWafBtn", ClearWafBtn);

import MissionModal from "@/components/GlobalMissionModal";
Vue.component("MissionModal", MissionModal);

import getResourceBtn from "@/components/getResourceBtn";
Vue.component("getResourceBtn", getResourceBtn);

let imageIsExist = function (url) {
    return new Promise((resolve) => {
        var img = new Image();
        img.onload = function () {
            if (this.complete == true) {
                resolve(true);
                img = null;
            }
        };
        img.onerror = function () {
            resolve(false);
            img = null;
        };
        img.src = url;
    });
};
Vue.directive("real-img", async function (el, binding) {
    let imgURL = binding.value;
    let imgSrc = el.getAttribute("src");
    if (imgSrc == imgURL) return;

    if (imgURL) {
        let exist = await imageIsExist(imgURL);
        if (exist) {
            el.setAttribute("src", imgURL);
        }
    }
});
// router
import router from "./router";
const LOGIN_PAGE_NAME = "login";
const NOTFOUND_PAGE = "error_404";
const ROOT_PAGE_NAME = "root";
const REQUIRE_UPGRADE_PAGE_NAME = "require_upgrade";

// Vuex
import store from "./store";

// 寫入外部獲取的平台配置
if (typeof _platformPrefs !== "undefined" && !isDevelop) {
    store.commit("SET_PLATFORM_PREFS", _platformPrefs);
}
const { userPref, platformPrefs } = store.state;

// 依照rcm.js內給定 決定圖表顏色配置
import colorScheme from "@/data/colorScheme";
if (platformPrefs.components.Chart.colorScheme != "") {
    let prefsColorScheme = platformPrefs.components.Chart.colorScheme;
    let customizeColorSchemeObj = {};

    for (let [color, rgb] of Object.entries(prefsColorScheme)) {
        let colorSchemeObj = {};
        let rgbStr = rgb.replace("rgba(", "").replace(")", "");
        let rgbArr = rgbStr.split(",");

        let fill = `rgba(${rgbArr[0]}, ${rgbArr[1]}, ${rgbArr[2]}, 1)`;
        let fillTransparent = `rgba(${rgbArr[0]}, ${rgbArr[1]}, ${rgbArr[2]}, 0.4)`;
        let border = `rgba(${rgbArr[0]}, ${rgbArr[1]}, ${parseInt(rgbArr[2]) + 10}, 1)`;
        let gradientStops = [];
        gradientStops.push(`rgba(${rgbArr[0]}, ${rgbArr[1]}, ${rgbArr[2]}, 1)`);
        gradientStops.push(`rgba(${rgbArr[0]}, ${rgbArr[1]}, ${rgbArr[2]}, 0)`);

        colorSchemeObj.fill = fill;
        colorSchemeObj.fillTransparent = fillTransparent;
        colorSchemeObj.border = border;
        colorSchemeObj.gradientStops = gradientStops;
        customizeColorSchemeObj[color] = colorSchemeObj;
    }
    // 替換colorScheme為cust自訂顏色
    for (let [color, rgbContent] of Object.entries(colorScheme)) {
        for (let [custColor, custRgba] of Object.entries(customizeColorSchemeObj)) {
            if (color == custColor) {
                colorScheme[color] = custRgba;
            } else {
                colorScheme[custColor] = custRgba;
            }
        }
    }
    // 替換自訂colorSet
    let colorSet = {};
    let fillSet = [];
    let borderSet = [];
    for (let [color, rgbContent] of Object.entries(customizeColorSchemeObj)) {
        if (color != "colorNames") {
            fillSet.push(rgbContent.fill);
            borderSet.push(rgbContent.border);
        }
    }
    colorSet["fill"] = fillSet;
    colorSet["border"] = borderSet;
    colorScheme["colorSets"] = colorSet;
}

// 國際化, 配置語系, 預設英文
import i18n from "./i18n";
const systemLangs = ["en-US", "zh-TW", "zh-CN"];
const userLang = userPref.lang || navigator.language || navigator.userLanguage;
const lang = userLang || systemLangs[0];
i18n.locale = lang;
store.commit("SET_USER_PREF", { lang });

import { setUserLang } from "@/api/user";
// // 傳遞語言配置至後台
// setUserLang({ userLang: lang })
//     .then((response) => {
//         console.log(`${response.data.message}`);
//     })
//     .catch((err) => {
//         console.log(`${err.message}`);
//     });

// 平台名稱,皮膚
const { brandTitle, themeName, layoutName } = platformPrefs;
document.body.className = themeName + " " + layoutName;

// Notify 組件
import { Notify } from "@/components/Middleware/notification";

if (store.getters.getNotificationName == "vue-notification") {
    Vue.prototype.$Notice = Notify;
}

ViewUI.Notice.config({
    duration: 10,
});

import { getPlatformPlan } from "@/api/system";

// 路由鉤子
// 驗證登入,和用戶權限
import { authMiddleware } from "@/libs/routerMiddleware/auth.js";
import { addQueryGroupNameMiddleware } from "@/libs/routerMiddleware/addQueryGroupName.js";
import { checkUserGroupRoleMiddleware } from "@/libs/routerMiddleware/checkUserGroupRole";
import { loadIntercomWidget } from "@/components/intercomWidget";

router.beforeEach(async (to, from, next) => {
    ViewUI.LoadingBar.start();

    let i18Title = `${i18n.t("routesMenu." + to.meta.title)} | ${brandTitle}`;
    document.title = i18Title || `${brandTitle}`;

    // 由於vue-router不支持嚴格意義上的middleware
    // 這邊的middleware主要是建構next參數, 最後統一處理
    // 有需要直接跳開的用catch處理
    try {
        // 有給群組
        if (to.query.groupName) {
            // 獲取平台限制
            await getPlatformPlan({ groupName: to.query.groupName })
                .then((res) => {
                    store.commit("SET_PLATFORM_PLAN", res.data);
                })
                .catch((err) => {
                    console.log(err);
                });
            store.commit("SET_QUERY_GROUPNAME", to.query.groupName);
        }
        for (let middleWare of [authMiddleware, addQueryGroupNameMiddleware, checkUserGroupRoleMiddleware]) {
            let { nextOption } = await middleWare(to, from);
            if (nextOption.name || nextOption.path) return next(nextOption);
            // 依照後台配置的 embedIntercomWidget 載入相關內容
            const { isEnabled, intercomAppId } = store.state.platformPlan.multiTenancyConfigs.embedIntercomWidget;
            if (isEnabled && intercomAppId) loadIntercomWidget(intercomAppId);
            next();
        }
    } catch (err) {
        console.log(err);
        next(err.nextOption);
    }
    if (
        (to.name != "login" && to.name != "logout" && from.name == "login") ||
        (from.name == null && to.name == "home")
    ) {
        // 傳遞語言配置至後台
        setUserLang({ userLang: lang })
            .then((response) => {
                console.log(`${response.data.message}`);
            })
            .catch((err) => {
                console.log(`${err.message}`);
            });
    }
});

router.afterEach((route) => {
    ViewUI.LoadingBar.finish();
    // ViewUI.Spin.hide();
});

// 使用者角色能力判定 （動作,母項目,頁面,欄位）
Vue.prototype.$can = (action, subject, page, params) => {
    // admin無敵
    if (store.getters.isAdmin) return true;

    let { currentGroupRolePermissions } = store.getters;

    let subjectPermission = currentGroupRolePermissions[subject];

    // 沒有母項目就不能操作
    if (!subjectPermission) return false;

    // 母項目有下一層
    if (subjectPermission.children) {
        let pagePermission = {};
        // 有傳頁面參數
        if (page) {
            // 找出頁面權限設定
            pagePermission = subjectPermission.children.find((e) => e.name == page);
            //有找到頁面權限
            if (pagePermission) {
                // 有傳欄位參數
                // if (params && pagePermission.children) {
                //     // 有找到頁面權限，找出欄位，且返回欄位權限
                //     let paramsPermission = pagePermission.children.find(e => e.name == params);
                //     return paramsPermission[action];
                // }
                //有找到頁面權限，沒有傳欄位參數，就返回頁面的權限設定
                return action == "other" ? pagePermission[action][params] : pagePermission[action];
            }
            //沒有找到頁面權限，就返回母項目的權限設定
            return subjectPermission[action];
        }
        // 沒有傳頁面參數，返回母項目權限設定
        return subjectPermission[action];
    }

    // 母項目沒有下一層，則返回母項目權限
    return subjectPermission[action];
};

new Vue({
    el: "#app",
    components: {
        App,
    },
    template: "<App/>",
    router,
    store,
    i18n,
});



// WEBPACK FOOTER //
// ./src/main.js